import * as t from "io-ts";

export const TagsV = t.union([
  t.literal("id"), // Element ID
  t.literal("parentId"), // Element's parent ID
  t.literal("selector"), // Element CSS Selector
  t.literal("parent_selector"),
  t.literal("postId"), // Parent-most post ID
  t.literal("ssr"), // SSR Content
  t.literal("children")
]);
export const TAGS_AVAILABLE: Tag[] = TagsV.types.map(({ value }) => value);
export type Tag = t.TypeOf<typeof TagsV>;
export type Tags = Partial<Record<Tag, string | number | null>>;
